'use client';

import React from 'react';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF7F50',
    },
    secondary: {
      main: '#334C66',
    },
    background: {
      default: 'rgb(247, 244, 242)',
      paper: '#ffffff',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#334C66',
          padding: '8px 0px',
          height: '69px',
          borderBottom: '2px solid #223347',
          boxShadow: 'none',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '69px !important',
          paddingLeft: '16px',
          paddingRight: '16px',
        },
      },
    },
  },
});

type ThemeProps = {
  children: React.ReactNode;
};

export default function AppTheme({ children }: ThemeProps) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
